import { Component, Input, OnInit } from '@angular/core';
import { IStateGoOpts } from 'Src/ng2/shared/services/prev-state/prev-state.service';

@Component({
  selector: 'data-entry-header',
  template: require('./data-entry-header.component.html'),
  styles: [require('./data-entry-header.component.scss')],
})
export class DataEntryHeaderComponent implements OnInit {
  @Input() currentRoute: string;
  @Input() schoolId: string;

  exitStateOpts: IStateGoOpts;

  constructor() {
    // empty block
  }

  ngOnInit() {
    this.exitStateOpts = {
      name: 'main.school.home',
      params: { schoolId: this.schoolId },
    };
  }
}
